import { render, staticRenderFns } from "./MaintenanceIngredients.vue?vue&type=template&id=78597f2b&scoped=true&"
import script from "./MaintenanceIngredients.vue?vue&type=script&lang=js&"
export * from "./MaintenanceIngredients.vue?vue&type=script&lang=js&"
import style0 from "./MaintenanceIngredients.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MaintenanceIngredients.vue?vue&type=style&index=1&id=78597f2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78597f2b",
  null
  
)

export default component.exports